import { useMediaQuery } from 'react-responsive'

const RESPONSIVE_BREAKPOINTS = Object.freeze({
  TABLET: 768,
  DESKTOP: 1280,
  WIDE_SCREEN: 1440,
})

type Breakpoint = 'wide-screen' | 'desktop' | 'tablet'

const responsiveQueries: Record<Breakpoint, string> = {
  'wide-screen': `(min-width: ${RESPONSIVE_BREAKPOINTS.WIDE_SCREEN}px)`,
  desktop: `(min-width: ${RESPONSIVE_BREAKPOINTS.DESKTOP}px)`,
  tablet: `(min-width: ${RESPONSIVE_BREAKPOINTS.TABLET}px)`,
}

export const useResponsive = (breakpoint: Breakpoint) => {
  return useMediaQuery({ query: responsiveQueries[breakpoint] })
}
